/**
 * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { AbstractTextColumn } from '../columnClass.js'
import { ColumnTypes } from '../columnHandler.js'
import { FilterIds } from '../filter.js'

export default class TextLongColumn extends AbstractTextColumn {

	constructor(data) {
		super(data)
		this.type = ColumnTypes.TextLong
	}

	getValueString(valueObject) {
		return valueObject.value.replace(/(<([^>]+)>)/ig, '')
	}

	isSearchStringFound(cell, searchString) {
		return super.isSearchStringFound(cell.value, cell, searchString)
	}

	isFilterFound(cell, filter) {
		const filterValue = (filter.magicValuesEnriched ? filter.magicValuesEnriched : filter.value).toLowerCase()
		const cellValue = cell.value?.toLowerCase()

		const filterMethod = {
			[FilterIds.Contains]() { return cellValue && cellValue.includes(filterValue) },
			[FilterIds.DoesNotContain]() { return cellValue && !cellValue.includes(filterValue) },
			[FilterIds.IsEmpty]() { return !cell.value },
			[FilterIds.IsNotEmpty]() { return !!cell.value },
		}[filter.operator.id]
		return super.isFilterFound(filterMethod, cell)
	}

}
